import { useState } from "react";
import { getCategories } from "../../services/categoryService";

const useCategories = () => {
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loadingCat, setLoadingCat] = useState(true);
  const [loadingSubCat, setLoadingSubCat] = useState(true);
  const [categoriesMenu, setCategoriesMenu] = useState([]);
  const [loadingCatMenu, setLoadingCatMenu] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = async (filters = { page: 1, limit: 6 }) => {
    setLoadingCat(true);
    try {
      const data = await getCategories(filters);
      setCategories(data);
      setLoadingCat(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoadingCat(false);
    }
  };

  const fetchSubCategories = async (filters = { page: 1, limit: 6 }) => {
    setLoadingSubCat(true);
    
    try {
      const data = await getCategories(filters);
      setSubCategories(data);
      setLoadingSubCat(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoadingSubCat(false);
    }
  };

  const fetchCategoriesMenu = async () => {
    setLoadingCatMenu(true);
    try {
      const data = await getCategories();
      setCategoriesMenu(data);
      setLoadingCatMenu(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoadingCatMenu(false);
    }
  };

  return {
    subCategories,
    categories,
    loadingCat,
    loadingSubCat,
    categoriesMenu,
    loadingCatMenu,
    error,
    fetchCategories,
    fetchSubCategories,
    fetchCategoriesMenu,
  };
};

export default useCategories;
